<div mat-dialog-title>
  <h1>Connect to TypeDB</h1>
  <tp-modal-close-button />
</div>
<div class="tp-modal-content">
  <tp-scroll-container class="tp-modal-body" mat-dialog-content>
    <h2>Install Console</h2>
    <p>Follow the instructions in our docs to
      <a class="tp-external-link" [href]="(consoleInstallDocsLink$ | async)" target="_blank">install TypeDB Console<i class="fa-light fa-arrow-up-right"></i></a>
    </p>
    <hr/>
    <h2>Connect to TypeDB</h2>
    @if (ready$ | async) {
      <p>Run the following command wherever you've installed TypeDB Console</p>
      @if (connectionCommand$ | async; as command) {
        <tp-code-snippet [snippet]="{ language: 'shell', code: command.replaceAll(' --', ' \\\n  --') }"/>
      }
      @if (data.cluster$ | async; as cluster) {
        <p>
          Your database password can be found in your downloaded credentials file if you have one
          (by default: <strong>{{ clusterCredentialFilename(cluster) }}</strong>).
        </p>
      }
    } @else if (loading$ | async) {
      @if (parsedVersion$ | async; as version) {
        <tp-cluster-loading-tips [clusterVersion]="version"/>
      }
    }
  </tp-scroll-container>
</div>
